// src/services/eventService.ts
import api from './api';
import { Event, CreateEventPayload } from '../types/church';

const EVENT_ENDPOINTS = {
  create: '/events',
  details: (id: number) => `/events/${id}`,
  update: (id: number) => `/events/${id}`,
  delete: (id: number) => `/events/${id}`,
};

export const createEvent = async (payload: CreateEventPayload): Promise<Event> => {
  console.log('📅 [EventService] Creating event:', payload);
  const response = await api.post<Event>(EVENT_ENDPOINTS.create, payload);
  console.log('✅ [EventService] Event created:', response.data);
  return response.data;
};

export const getEventById = async (id: number): Promise<Event> => {
  console.log('📅 [EventService] Fetching event by id:', id);
  const response = await api.get<Event>(EVENT_ENDPOINTS.details(id));
  console.log('✅ [EventService] Event details fetched:', response.data);
  return response.data;
};

export const updateEvent = async (id: number, payload: Partial<CreateEventPayload>): Promise<Event> => {
  console.log('📅 [EventService] Updating event:', id, payload);
  const response = await api.put<Event>(EVENT_ENDPOINTS.update(id), payload);
  console.log('✅ [EventService] Event updated:', response.data);
  return response.data;
};

export const deleteEvent = async (id: number): Promise<void> => {
  console.log('📅 [EventService] Deleting event:', id);
  await api.delete(EVENT_ENDPOINTS.delete(id));
  console.log('✅ [EventService] Event deleted');
};

// ==================== IMAGE UPLOAD ====================

export interface ImageUploadResponse {
  success: boolean;
  message: string;
  url: string;
  thumbnail_url?: string;
  file_size?: number;
}

// Upload image de l'événement
export const uploadEventImage = async (
  eventId: number,
  file: File,
  onProgress?: (progress: number) => void
): Promise<ImageUploadResponse> => {
  console.log('🖼️ [EventService] Uploading event image:', eventId);
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post<ImageUploadResponse>(
    `/events/${eventId}/image`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000, // 60 seconds
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(progress);
        }
      },
    }
  );
  console.log('✅ [EventService] Event image uploaded:', response.data);
  return response.data;
};

// Supprimer image de l'événement
export const deleteEventImage = async (eventId: number): Promise<void> => {
  console.log('🗑️ [EventService] Deleting event image:', eventId);
  await api.delete(`/events/${eventId}/image`);
  console.log('✅ [EventService] Event image deleted');
};
